import { render, staticRenderFns } from "./TaxSummary.vue?vue&type=template&id=f48a225e&scoped=true"
import script from "./TaxSummary.vue?vue&type=script&lang=js"
export * from "./TaxSummary.vue?vue&type=script&lang=js"
import style0 from "./TaxSummary.vue?vue&type=style&index=0&id=f48a225e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48a225e",
  null
  
)

export default component.exports